export default __webpack_public_path__ + "static/media/carimg.557742c6.jpg";